import React, { Component } from 'react';

export const Loader = () => {

    return (
        <div className='loaerOuter'>
            <span class="loader"></span>
        </div>
    )
}